/**
 * Агрегаты шапки Plan для отчёта quantity/departments:
 * planQuantity* ← sum(Plan.Amount) по departmentId
 * planSum* ← CostCoefficient * Amount * Price
 */
export function buildPlanRollupFromIndices(planIndices = [], fields = {}) {
  const parseNumber = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const active = (planIndices || []).filter((r) => r && !r._isDeleted);

  const amountFromIndices = active.reduce(
    (acc, r) => acc + parseNumber(r.plannedResearch),
    0
  );
  const plannedSumFromIndices = active.reduce(
    (acc, r) => acc + parseNumber(r.plannedSum),
    0
  );

  const byDept = new Map();
  active.forEach((r) => {
    const deptId = Number(r.departmentId ?? r.department?.id);
    if (!Number.isFinite(deptId) || deptId <= 0) return;
    const qty = parseNumber(r.plannedResearch);
    byDept.set(deptId, (byDept.get(deptId) || 0) + qty);
  });

  let departmentId =
    fields.departmentId != null && fields.departmentId !== ""
      ? Number(fields.departmentId)
      : null;
  if (!(Number.isFinite(departmentId) && departmentId > 0)) {
    departmentId = null;
    let bestQty = -1;
    byDept.forEach((qty, id) => {
      if (qty > bestQty) {
        bestQty = qty;
        departmentId = id;
      }
    });
  }

  let amount = parseNumber(fields.amount);
  if (!(amount > 0)) {
    amount = amountFromIndices;
  }

  let price = parseNumber(fields.price);
  if (!(price > 0) && amount > 0 && plannedSumFromIndices > 0) {
    price = plannedSumFromIndices / amount;
  }

  let costCoefficient = parseNumber(fields.costCoefficient);
  // 0 обнуляет planSum на бэке — если не задан, считаем 1
  if (!(costCoefficient > 0)) {
    costCoefficient = 1;
  }

  const sum =
    costCoefficient * amount * price > 0
      ? costCoefficient * amount * price
      : plannedSumFromIndices;

  return {
    amount,
    price,
    costCoefficient,
    departmentId:
      Number.isFinite(departmentId) && departmentId > 0 ? departmentId : null,
    sum,
  };
}
